import React from 'react'
import ReactTooltip from 'react-tooltip'
import './boardVisual.css'
import './annotation/annotation.css'
import '../../App.css'
import AtmosicTip from './atmosic-tip'

import { Table } from 'reactstrap'

import DRQFN from './packages/drqfn.js';
import QFN40 from './packages/qfn40.js';

import ATM3X_QFN56 from './packages/ATM3x/qfn56.js'
import ATM3X_QFN40 from './packages/ATM3x/qfn40.js'
import ATM3X_QFN40_REDUCED_PMU from './packages/ATM3x/qfn40_reduced_pmu.js'
import ATM3X_WLCSP49_REDUCED_PMU from './packages/ATM3x/wlcsp49_reduced_pmu.js'
import ATM3X_QFN40_STACKED_FLASH from './packages/ATM3x/qfn40_stacked_flash.js'
import ATM3X_BGA93 from './packages/ATM3x/bga93.js'
import ATM5X_QFN40 from './packages/ATM5x/qfn40.js'
import ATM5X_BGA93 from './packages/ATM5x/bga93.js'

import { get_version, x2xxPlats, m33Plats, _5xxxPlats } from '../../utes/appUtils'

class SvgComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state={
            activeList: {},
            scrollIndex:-1,
            didMount: false,
            pinRefs: Array(34),
            tableHeight: 200,
            columnWidth:180
        };
        this.heightCounter = 0;
        this.refList = this.props.pinStatus.map(() => {
            return React.createRef();
        });
        this.setIndex=this.setIndex.bind(this);
        this.beforePrint=this.beforePrint.bind(this);
        this.afterPrint=this.afterPrint.bind(this);

    }

    componentDidUpdate(prevProps, prevState) {
        ReactTooltip.rebuild()
        if (this.state.scrollIndex !== prevState.scrollIndex && this.activeRowRef) {
            this.activeRowRef.scrollIntoView({block: 'center'})
        }
    }

    beforePrint() {
            this.setState({tableHeight:1200,
                columnWidth:100
            })
    }

    afterPrint() {
            this.setState({tableHeight:200,
                columnWidth:300
            })
    }

    componentDidMount() {
        if (window.matchMedia) {
            var oldthis = this;
            var mediaQueryList = window.matchMedia('print');
            mediaQueryList.addEventListener("change", function(mql) {
                if (mql.matches) {
                    oldthis.beforePrint();
                } else {
                    oldthis.afterPrint();
                }
            });
        }

        window.onbeforeprint = this.beforePrint;
        window.onafterprint = this.afterPrint;


        let pinRefs = this.refList.map((ref,index) => {
            if (ref.current !== null) {
                return ref;
            }
            return null;
        })
        this.setState({pinRefs:pinRefs})
    }

    setIndex(pinNumber) {
        let index = this.props.activeList.findIndex((e)=> {
            return (e.pin === pinNumber);
        })
        this.setState({scrollIndex: index})
    }

    render() {
        let svg;

        let cur_version = get_version(this.props.board);
        let view_direction = "Top"

        if (_5xxxPlats.includes(cur_version)) {
            let bga = (this.props.board.match(/ATM5[0-9x]{3}-xxxxBV/) !== null);

            if (bga) {
                view_direction = "Bottom"
                svg = <ATM5X_BGA93 pinStatus={this.props.pinStatus} />;
            } else {
                svg = <ATM5X_QFN40 pinStatus={this.props.pinStatus} />;
            }
        } else if (m33Plats.includes(cur_version)) {
            // ATM33 Packages with reduced functionality
            let reduced_pmu =    (this.props.board.match(/ATM33[02]{1}5/) !== null);
            let stacked_flash =  (this.props.board.match(/ATM33[02]{1}5-[5x][LWY]xxQK/) !== null);

            // General ATM33/ATM34 packages
            const m33pattern = 'ATM3[34]{1}[0-9]{2}[ex]?-[5x][DLPWYx]xx';

            const m33BoardMatch = (board, suffix) => {
                const regex = new RegExp(m33pattern + suffix);
                return regex.test(board);
            }

            let seven_by_seven = m33BoardMatch(this.props.board, 'QN');
            let csp = m33BoardMatch(this.props.board, 'CM');
            let bga = m33BoardMatch(this.props.board, 'BV');

            /* Reduced PMU for ATM33 */
            if (reduced_pmu) {
                if (csp) {
                    view_direction = "Bottom"
                    svg = <ATM3X_WLCSP49_REDUCED_PMU pinStatus={this.props.pinStatus} />;
                } else if (stacked_flash) {
                    svg = <ATM3X_QFN40_STACKED_FLASH pinStatus={this.props.pinStatus} />
                } else {
                    svg = <ATM3X_QFN40_REDUCED_PMU pinStatus={this.props.pinStatus} />;
                }
            } else if (bga) {
                view_direction = "Bottom"
                svg = <ATM3X_BGA93 pinStatus={this.props.pinStatus} />;
            } else if (seven_by_seven) {
                svg = <ATM3X_QFN56 pinStatus={this.props.pinStatus} />;
            } else {
                svg = <ATM3X_QFN40 pinStatus={this.props.pinStatus} />;
            }
        } else if (x2xxPlats.includes(cur_version)) {
            let six_by_six = (this.props.board.match(/ATM.{1}[0-9]2[0-9]/) !== null);
            let stacked_flash = (this.props.board.match(/ATM.{1}202/) !== null);
            if (six_by_six) {
                svg = <DRQFN pinStatus={this.props.pinStatus} />
            } else {
                svg = <QFN40 pinStatus={this.props.pinStatus} stackedFlash={stacked_flash} />
            }
        }

        return(
            <div id="divToPrint">
                <div className="svg-wrapper">
                    {svg}
                </div>
                <div>
                    <span className="svg-facing">{view_direction} view</span>
                </div>
                <Table borderless hover size="sm" className="pin-row" style={{width: '100%', maxWidth: 1200, margin: '0 auto'}}>
                    <thead>
                        <tr className="head">
                            <th style={{width: this.state.columnWidth}}>Pin</th>
                            <th style={{width: this.state.columnWidth}}>Peripheral</th>
                            <th style={{width: this.state.columnWidth}}>Signal</th>
                            <th style={{width: this.state.columnWidth}}>Pullup</th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.props.activeList.map((row, index) => (
                            <tr
                                key={row.pin}
                                className={`pin-row ${index % 2 === 0 ? 'even' : 'odd'}`}
                                ref={index === this.state.scrollIndex ? el => (this.activeRowRef = el) : null}
                            >
                                <td style={{width: this.state.columnWidth}}>{row.pin}</td>
                                <td style={{width: this.state.columnWidth}}>{row.Peripheral}</td>
                                <td style={{width: this.state.columnWidth}}>{row.signal}</td>
                                <td style={{width: this.state.columnWidth}}>{row.pullup}</td>
                            </tr>
                        ))}
                    </tbody>
                </Table>
                <ReactTooltip id='fixedPin' effect='solid' type="dark"/>
                <ReactTooltip id='setablePin' effect='solid' type="info"/>
                <AtmosicTip id='usedPin'
                            effect='solid'
                            clickCallback={this.setIndex}
                            type="success"
                            getContent={ (data_tip) => {
                                if (/^P\d+$/.test(data_tip)) {
                                    let pin = data_tip.substr(1);
                                    let current_pin_status = this.props.pinStatus[pin];
                                    let content = data_tip;
                                    if ((this.props.TMCActive) && (pin < 3)) {
                                        if (pin === 0) {
                                            content += "[TMC][jtag_sel]"
                                        } else if (pin === 1) {
                                            content += "[TMC][swdclk]"
                                        } else if (pin === 2) {
                                            content += "[TMC][swdclk]"
                                        }
                                        return content;
                                    } else if (current_pin_status !== null) {
                                        let inUsePeri = this.props.peripherals.find(function (element) {
                                            return element.name === current_pin_status.periName;
                                        });
                                        let periName = current_pin_status.periName;
                                        let pos = current_pin_status.pos;
                                        let pinNames = inUsePeri.pinNames;
                                        let pinName = pinNames[pos];
                                        if (periName === 'gpio') {
                                            pinName = (pin <= 13) ? pin : (pin - 4);
                                        }
                                        if ((current_pin_status !== null) && (current_pin_status !== -1)) {
                                            content = content + " [" + current_pin_status.periName + "]["+pinName+"]";
                                        }
                                        return content
                                    }
                                } else {
                                  return data_tip;
                                }
                            }}
                    />
            </div>
        );
    }
}

export default SvgComponent
